import '../style/card-CQctoLTB.css'
import { defineComponent as k, useSlots as S, computed as a, openBlock as t, createElementBlock as c, normalizeClass as n, normalizeStyle as h, renderSlot as r, createTextVNode as b, toDisplayString as C, createBlock as _, unref as y, withCtx as z, createVNode as E, createCommentVNode as m, createElementVNode as N } from "vue";
import R from "./link.js";
import V from "./icon-button.js";
import { getStyle as D, getSpaceClass as f, SpaceTypeEnum as v, getPaddingDirection as F } from "./utils/style.js";
import { DEFAULT_SIZE as T } from "./constant/common.js";
const U = /* @__PURE__ */ k({
  name: "e-card",
  __name: "card",
  props: {
    title: {},
    boxShadow: {},
    padding: {},
    isBordered: { type: Boolean },
    headerLink: {},
    size: {},
    headerPadding: {},
    bodyPadding: {},
    isFlex: { type: Boolean },
    loading: { type: Boolean },
    noRadius: { type: Boolean }
  },
  setup(i) {
    const s = i, l = S(), o = a(() => !!s.title || !!l.header), u = a(() => D(s));
    function p(e, d = 16) {
      return e ?? d;
    }
    const B = a(() => {
      const e = ["e-card"];
      return s.noRadius && e.push("e-card--no-radius"), s.isBordered && e.push("e-card--bordered"), s.size && s.size !== T && e.push(`e-card--${s.size}`), s.isFlex && e.push("e-card--is-flex"), e;
    }), g = a(() => p(s.headerPadding, s.padding)), $ = a(() => {
      const e = [];
      return e.push(f(v.Padding, g.value)), e;
    }), L = a(() => ({
      right: `${F(g.value, "right") / 2}px`
    })), P = a(() => {
      const e = [];
      o.value && s.bodyPadding === void 0 && e.push("pt-0");
      const d = p(s.bodyPadding, s.padding);
      return e.push(f(v.Padding, d)), e;
    });
    return (e, d) => (t(), c("div", {
      class: n(B.value),
      style: h(u.value)
    }, [
      e.title || e.$slots.header ? (t(), c("div", {
        key: 0,
        class: n(["e-card__header", $.value])
      }, [
        e.loading ? r(e.$slots, "header-skeleton", { key: 0 }) : r(e.$slots, "header", { key: 1 }, () => [
          b(C(e.title) + " ", 1),
          e.headerLink ? (t(), _(y(R), {
            key: 0,
            to: e.headerLink,
            ripple: !0,
            class: "e-card__header-link",
            style: h(L.value)
          }, {
            default: z(() => [
              E(y(V), {
                color: "var(--text-primary)",
                icon: "chevron-right",
                "hover-scale": "",
                "icon-size": 20,
                "button-size": 32
              })
            ]),
            _: 1
          }, 8, ["to", "style"])) : m("", !0)
        ])
      ], 2)) : m("", !0),
      N("div", {
        class: n(["e-card__body", P.value])
      }, [
        e.loading ? r(e.$slots, "body-skeleton", { key: 0 }) : r(e.$slots, "default", { key: 1 })
      ], 2),
      r(e.$slots, "fixed")
    ], 6));
  }
}), Z = /* @__PURE__ */ k({
  name: "e-card-group",
  __name: "card-group",
  props: {
    divider: { type: Boolean, default: !0 },
    noRadius: { type: Boolean }
  },
  setup(i) {
    const s = i, l = a(() => ["e-card-group", { "e-card-group--divider": s.divider }, { "e-card-group--no-radius": s.noRadius }]);
    return (o, u) => (t(), c("div", {
      class: n(l.value)
    }, [
      r(o.$slots, "default")
    ], 2));
  }
});
export {
  U as Card,
  Z as CardGroup
};
//# sourceMappingURL=card.js.map
